<template>
  <div id="app">
    <myhead title="VIP服务"></myhead>
    <div class="page">
      <centerInfo :userInfo="userInfo"></centerInfo>
      <div id="vipOpenContent">
        <div class="app-msg">
          <div>
            <span class="app-msg-title">开通VIP，使用专享伪装APP</span>
          </div>
          <div class="app-ba">
            <img src="../../assets/img/center-lo-1@2x.png" alt />
            <div class="app-ba-content">伪装升级、功能强大，360°保护您的隐私</div>
          </div>
        </div>
      </div>

       <!-- VIP功能 -->
         <div class="app-name-div">
        <img src="../../assets/img/app-info-name@2x.png" alt />
        <div class="app-ba-content">VIP功能</div>
      </div>

       <!-- VIP功能 -->
      <div class="vip-gong">
        <ul>
          <li>VIP功能</li>
          <li>贴心的效果</li>

          <li>一键返回浮窗</li>
          <li>
            <span class="right-desc">突发情况，一键返回</span>
            <button
              @click="openViveo('http://img.haoyunba.com/yijianfanhuiweizhuangyemian.mp4')"
            >演示></button>
          </li>

          <li>需要伪装外壳</li>
          <li>
            <span class="right-desc">切应用/锁屏等，自动伪装</span>
            <button
              @click="openViveo('http://img.haoyunba.com/buxuyaoweizhuangwaikegongneng.mp4')"
            >演示></button>
          </li>

          <li>定时自动返回</li>
          <li>
            <span class="right-desc">有效避免酒后泄露隐私</span>
            <button @click="openViveo('http://img.haoyunba.com/zidongfanhuigongneng.mp4')">演示></button>
          </li>

          <li>同步聊天记录</li>
          <li>
            <span class="right-desc">长达2年，留住亲密时光</span>
            <button @click="openViveo('http://img.haoyunba.com/tongbuliaotianjilu.mp4')">演示></button>
          </li>

          <li>保密时段</li>
          <li>
            <span class="right-desc">保密时间，无人可进入</span>
            <button @click="openViveo('http://img.haoyunba.com/baomisiduangongneng.mp4')">演示></button>
          </li>

          <li>翻转返回</li>
          <li>
            <span class="right-desc">翻转手机即可紧急伪装</span>
            <button @click="openViveo('http://img.haoyunba.com/fzfanhui.mp4')" >演示></button>
          </li>
        </ul>
      </div>

       <!-- VIP功能 end-->

       <!-- VIP功能 VIP特权-->

      <div class="app-name-div">
        <img src="../../assets/img/app-info-name@2x.png" alt />
        <div class="app-ba-content">VIP特权</div>
      </div>

      <div v-if='!iosflag ' class="vip-t mar-fei">
        <div class="vip-t-1">
          <img src="../../assets/img/vip-fei-1.png" alt />
        </div>

        <!-- 伪装app的下 -->
        <div v-if='!iosflag '  class="wz-app vip-app mar-t">
          <ul>
            <li>
              <img src="../../assets/img/logo-jsq.png" alt />
              <p>计算器APP</p>
            </li>
            <li>
              <img src="../../assets/img/logo-txs.png" alt />
              <p>资讯APP</p>
            </li>
            <li>
              <img src="../../assets/img/logo-xxl.png" alt />
              <p>学习类APP</p>
            </li>
            <li>
              <img src="../../assets/img/logo-clac.png" altw />
              <p>
                安卓各手机
                <br />同款计算器APP
              </p>
            </li>
            <li>
              <img src="../../assets/img/logo-xw.png" alt />
              <p>
                多种名称和
                <br />外壳资讯APP
              </p>
            </li>
          </ul>
              <!-- VIP功能 VIP特权 end-->

          <!--文案显示 -->
        <div  v-if='!iosflag'  class="vip-t-d">
            <img v-if='!iosflag'  src="../../assets/img/vip-declare@2x.png" alt />
            <img v-if='iosflag'  src="../../assets/img/vip-declare@2x.png" alt />
        </div>

        <div class="vip-t-desc">
            为了您的聊天更隐蔽更安全，强烈建议您：每隔一个月到【好运吧】官网<span class="vip-t-desc-span" >&nbsp; haoyunba.com&nbsp;</span>下载不同类型的伪装APP使用<br />
            <span class="vip-t-desc-t">(我们将不定期发布不同类型不同皮肤不同名称的伪装APP)</span>
        </div>


          <div class="vip-t-2">
            <img src="../../assets/img/vip-fei-2.png" alt />
          </div>

          <div class="vip-t-3">
            <img src="../../assets/img/vip-fei-3.png" alt />
          </div>
        </div>
      </div>
      <div  v-if='iosflag' >
          <!--文案显示 -->
        <div  v-if='!iosflag'  class="vip-t-d">
            <img v-if='!iosflag'  src="../../assets/img/vip-declare@2x.png" alt />
            <img v-if='iosflag'  src="../../assets/img/vip-declare-1@2x.png" alt />

         </div>

        <div v-if='!iosflag'  class="vip-t-desc">
            为了您的聊天更隐蔽更安全，强烈建议您：每隔一个月到【好运吧】官网<span class="vip-t-desc-span" >&nbsp; haoyunba.com&nbsp;</span>下载不同类型的伪装APP使用<br />
            <span class="vip-t-desc-t">(我们将不定期发布不同类型不同皮肤不同名称的伪装APP)</span>
        </div>


          <div class="vip-t-2">
            <img  v-if='!iosflag'   src="../../assets/img/vip-fei-2.png" alt />
            <img   v-if='iosflag'  src="../../assets/img/vip-fei-2-1.png" alt />

          </div>

          <div class="vip-t-3">
            <img src="../../assets/img/vip-fei-3.png" alt />
          </div>
        </div>

   


     <div class="app-name-div">
        <img src="../../assets/img/app-info-name@2x.png" alt />
        <div class="app-ba-content">VIP费用</div>
      </div>

      <div class="vip-fei">
        <!-- <img src="../../assets/img/vip-fei.png" alt /> -->
        <div class="vip-fei-page">

<ul class="vip-desc">
          <li>VIP等级</li>
          <li>VIP价格</li>
        </ul>
        <ul class="vip-s">
          <!-- <li>
            永久VIP
            <img src="../clac/img/bysy.png" />
          </li>
          <li>
            <div class="ry">1398元</div>
            <div class="yy">5200</div>
          </li> -->
         <div  v-for="(item ,index) in vipdata ">
               <li class="vip-s-li-one">
                {{ item.name }}
                <img  v-show="item.st == 1" src="../clac/img/bysyss.png" />
              </li>
              <li class="vip-s-li-two" >
                <div class="ry"  v-show="!iospriceflag" >{{ item.price }}</div>
                <div class="ry" v-show="iospriceflag" >{{ item.aprice }}</div>

                <div class="yy">  {{ item.yprice }}</div>
                <img  v-show="item.st == 1 && item.cmtimg != ''" :src="item.cmtimg" />

              </li>
         </div>
         
         
          <!-- <li>
            六个月VIP
            <img src="../clac/img/bysy.png" />
          </li>
          <li>
            <div class="ry">518元</div>
            <div class="yy">1188</div>
          </li>
          <li>
            三个月VIP
            <img src="../clac/img/bysy.png" />
          </li>
          <li>
            <div class="ry">288元</div>
            <div class="yy">588</div>
          </li>
          <li>一个月VIP</li>
          <li>
            <div class="ry">98元</div>
            <div class="yy">199</div>
          </li> -->
        </ul>
      </div>
        <div class="vip-yong-text">
          买一送一：你买VIP，你的好友也可获得同等VIP。
        </div>
      </div>
     

      <div class="app-ba app-ba-bottom">
        <img src="../../assets/img/vip-desc-bianzu@2x.png" alt />
        <div class="app-ba-content">推荐购买永久VIP，一次购买终身使用</div>
      </div>
      <div class="app-list-desc">VIP功能全面，避免任何意外！</div>

      <div class="app-state">
        <img src="../../assets/img/vip-declare@2x.png" alt />
        <br />
        <div class="app-state-desc">
          <span>
            所有环节均采用金融级加密技术
            <br />极致的保护隐私，是我们共同的追求
          </span>
        </div>
      </div>
      <vipBotton></vipBotton>
    </div>

    <videoVue ref="videoVue"></videoVue>
  </div>
</template>
<script>
import myhead from "../common/head";
import centerInfo from "../common/centerInfo2";
import vipOpenContent from "../common/vipOpenContent";
import vipOpenButton from "../common/vipOpenButton";
import vipContent from "../common/vipContent";
import vipDesc from "../common/vipDesc";
import vipBotton from "../common/vipBotton2";
import vipYong from "../common/vipYong";
import store from "../../store/index";
import * as types from "../../store/types";
import { mapGetters } from "vuex";
import videoVue from "../common/video";

export default {
  metaInfo: {
    title: "VIP服务"
  },
  name: "app",
  data() {
    return {
      msg: "VIP服务",
      userInfo: { viptype: 3 },
      yongvip: {
        titles: ["土豪专享!安臻之选!"],
        descs: ["联系客服，私人定制伪装App", "因为独一无二·所以最安全"]
      },
      vipdata:[
         {"name":"永久VIP","price":999,"aprice":1298,"yprice":5200,st:1,cmtimg:"../../../static/img/vipvip1.png"},
        {"name":"一年VIP","price":798,"aprice":1098,"yprice":1999,st:1,cmtimg:""},
        {"name":"六个月VIP","price":398,"aprice":588,"yprice":1188,st:1,cmtimg:"../../../static/img/vipvip2.png"},
        {"name":"三个月VIP","price":218,"aprice":288,"yprice":588,st:0,cmtimg:""},
        {"name":"一个月VIP","price":98,"aprice":128,"yprice":199,st:0,cmtimg:""}
      ],
      list: [],
      iosflag:true,
      aflag:true,
      iospriceflag:true
    
    };
  },
  mounted() {
    this.$point.init(new Date());
    store.dispatch("hideLoading");

    this.userInfo = this.getUserInfo;

    var token = this.getToken;
    var listData = this.getUserList;
    var token = this.getToken;
    console.log("store里面的toekn有值" + JSON.stringify(token));
    if (token == null || token == "") {
      token = localStorage.getItem("token");
      console.log("localStorage缓存token：" + token);
      store.commit(types.LOGIN, token);
    }
    if (token == "" || token == null) {
      this.$router.push("/login");
    }
  
  },
  created() {
    var ua = navigator.userAgent;
    if (ua.indexOf("T00991") > -1 ) {
      this.iosflag = true; 
    }else{
      this.iosflag = false;    
      this.iospriceflag = false;         
      
    }
    console.log("结果测试:"+ua)

    if ( this.changeNOfen()) {
      this.iosflag = true;          
    }

    this.userInfo = this.getUserInfo;
  },
  methods: {
    openViveo(a) {
      console.log("父组件url:" + a);
      this.$refs.videoVue.openTan(a);
    },
    changeNOfen(){
    var cid = this.getChannel
    console.log("cid:"+cid)

        console.log("结果测试:"+cid)


    if(cid == 'T00001'){
        return true;
    }
     if(cid == 'T00002'){
        return true;
    }
     if(cid == 'T00003'){
        return true;
    }
     if(cid == 'T00005'){
        return true;
    }
     if(cid == 'T00006'){
        return true;
    }
     if(cid == 'T00007'){
        return true;
    }
     if(cid == 'T00008'){
        return true;
    }
     if(cid == 'T00009'){
        return true;
    }
     if(cid == 'T000010'){
        return true;
    }
     if(cid == 'T000011'){
        return true;
    }
     if(cid == 'T000012'){
        return true;
    }
     if(cid == 'T000013'){
        return true;
    }
    return false;
    }
  },
  computed: {
    ...mapGetters([
      "getWxAlert",
      "loading",
      "getUserInfo",
      "getToken",
      "getChannel",
      "getUserList"
    ])
  },
  components: {
    myhead,
    centerInfo,
    vipOpenContent,
    vipOpenButton,
    vipContent,
    vipDesc,
    vipBotton,
    vipYong,
    videoVue
  }
};
</script>
<style  scoped>
.page {
  width: 750px;
  height: auto;
  background-image: url("../../assets/img/background@2x.png");
  padding: 28px 0px 40px 0px;
  background-size: cover;
}

.app-state {
  width: 100%;
  height: auto;
}

.app-state img {
  width: 130px;
  height: 10px;
}
.app-state-desc {
  width: 100%;
  height: 76px;
  margin: 26px auto 160px auto;
}

.app-state span {
  width: 384px;
  height: 76px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  line-height: 34px;
}

.app-msg {
  height: 100px;
  text-align: center;
  margin: 36px auto 44px auto;
}
.app-msg-title {
  width: 288px;
  height: 66px;
  font-size: 48px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(245, 195, 167, 1);
  line-height: 66px;
  background: linear-gradient(
    148deg,
    rgba(233, 205, 181, 1) 0%,
    rgba(214, 170, 150, 1) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.app-ba {
  width: 670px;
  height: 200px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  line-height: 40px;
  margin: 0 auto;
}

.app-ba img {
  width: 100%;
  height: 10px;
}

.app-ba-content {
  position: relative;
  top: -35px;
}

.app-name-div {
  width: 344px;
  height: 44px;
  font-size: 36px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  line-height: 40px;
  margin: 132px auto 50px auto;
}

.app-name-div img {
  width: 100%;
  height: 1;
}

.vip-fei {
  width: 630px;
  height: 471px;
  margin: 0 auto;
}

.vip-fei img {
  height: 100%;
  width: 100%;
}

.vip-t {
  width: 630px;
  height: auto;
  margin: 0 auto;
}

.wz-app {
  min-height: 500px;
  width: 603px;
  margin: 40px auto 30px;
}

.wz-app ul {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 470px;
}
.wz-app ul li {
  padding: 0;
  margin: 0;
  height: 200px;
  float: left;
  width: 150px;
  list-style: none;
  text-align: center;
}
.wz-app ul li img {
  width: 120px;
  height: 116px;
  /* background: rgba(248, 255, 255, 1);
  box-shadow: 0px 0px 20px 5px rgba(166, 220, 239, 0.3); */
  border-radius: 26px;
}

.wz-app ul li p {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 25px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  text-align: center;
  color: rgba(245, 195, 167, 1);
  margin-top: 25px;
}
.wz-app ul li:nth-child(2) {
  float: left;
  margin-left: 80px;
}
.wz-app ul li:nth-child(3) {
  float: right;
}

.vip-app ul li:nth-child(4) {
  width: 160px;
  margin-top: 20px;
  margin-left: 120px;
}
.vip-app ul li:nth-child(5) {
  margin-top: 20px;
  margin-left: 80px;
}

.wz-app-down {
  width: 153px;
  height: 25px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(40, 119, 227, 1);
  border: none;
  float: right;
}
.vip-t-1 {
  width: 292px;
  height: 53px;
  margin: 0 auto;
}
.vip-t-1 img {
  width: 100%;
  height: 100;
}

.vip-t-2 {
  width: 292px;
  height: 53px;
  margin: 60px auto 50px;
}
.vip-t-2 img {
  width: 100%;
  height: 100;
}

.vip-t-3 {
  width: 634px;
  height: 248px;
  margin: 40px auto 0px;
}
.vip-t-3 img {
  width: 100%;
  height: 100;
}

.app-ba {
  width: 624px;
  height: 46px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  line-height: 40px;
  margin: 100px auto 20px auto;
}

.app-ba img {
  width: 100%;
  height: 10px;
}

.app-ba-content {
  position: relative;
  top: -35px;
}

.app-list-desc {
  width: 100%;
  height: 40px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #b59991;
  line-height: 40px;
  margin: 0px auto 32px auto;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(241, 195, 167, 1);
}
.mar-fei {
  margin-top: 60px;
}
.mar-t {
  margin-top: 60px;
}

.vip-gong {
  width: 666px;
  height: 580px;
  margin: 20px auto 0px;
}

.vip-gong-title {
  height: 34px;
  font-size: 36px;
  font-family: PingFang SC;
  font-weight: 600;
  color: rgba(40, 119, 227, 1);
  text-align: left;
}

.vip-gong ul {
  width: 100%;
  height: 56px;
  margin: 40px auto 0px;
  padding: 0;
}

.vip-gong ul li {
  float: left;
  list-style: none;
  width: 49%;
  height: 78px;
  background: #2c3163;
  line-height: 78px;
}
.vip-gong ul li:nth-child(2n + 1) {
  width: 30%;
  text-align: center;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #f5c4a7;
  border-bottom: 2px solid #161b4b;
  border-left: 2px solid #161b4b;
}
.vip-gong ul li:nth-child(2n) {
  width: 69%;
  text-align: left;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #f5c4a7;
  border-bottom: 2px solid #161b4b;
  border-left: 2px solid #161b4b;
  border-right: 2px solid #161b4b;
}
.right-desc {
  margin-left: 25px;
}
.vip-gong ul li button {
  width: 109px;
  height: 40px;
  background: linear-gradient(90deg, #eeb08e, #f9dcc1);
  border-radius: 20px;
  border: none;
  float: right;
  color: #161b4b;
  margin: 18px 15px 0 0;
  font-weight: 600;
}

.vip-gong ul li:nth-child(1) {
  width: 30%;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #161b4b;
  background: linear-gradient(90deg, #eeb08e, #f9dcc1);
  border-bottom: 2px solid #161b4b;
  border-left: 2px solid #161b4b;
}
.vip-gong ul li:nth-child(2) {
  width: 69%;
  font-size: 30px;
  text-align: center;
  font-family: PingFang SC;
  font-weight: 600;
  color: #161b4b;
  background: linear-gradient(90deg, #eeb08e, #f9dcc1);
  border-bottom: 2px solid #161b4b;
  border-left: 2px solid #161b4b;
  border-right: 2px solid r#161B4B;
}
.app-ba-bottom {
  font-size: 31px;
  font-family: PingFang SC;
  font-weight: 800;
  color: rgba(241, 195, 167, 1);
  top: -30px;
}
.vip-fei-page {
  width: 630px;
  height: 500px;
  margin: 0 auto;
  z-index: 100;
}
.vip-fei-page-p {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #ffffff;
  text-align: center;
  margin-top: 32px;
}
.vip-fei-page ul {
  margin: 0;
  padding: 0;
  width: 100%;
  text-align: center;
}
.vip-fei-page ul li {
  height: 80px;
  float: left;
  list-style: none;
  text-align: center;
}
.vip-desc {
  background-image: linear-gradient(90deg, #eeb08e 4%, #f9dcc1 100%);
  height: 80px;
  line-height: 80px;
  font-family: PingFangSC-Semibold;
  font-size: 26px;
  color: #2b2f3c;
  letter-spacing: -0.07px;
  text-align: center;
  font-weight: 700;
}
.vip-desc li {
  width: 50%;
}

.vip-s {
  height: 74px;
  font-family: PingFangSC-Regular;
    font-size: 28px;
  color: #f4bf9d;
  letter-spacing: -0.06px;
  text-align: center;
  line-height: 74px;
  font-weight: 500;
}
.vip-s li {
  background: #2c3163;
  width: 253px;
    font-size: 28px;

}
.vip-s li .ry {
  width: 133px;
  height: 100%;
  float: left;
  text-align: right;
}
.vip-s li .yy {
  width: 93px;
  height: 100%;
  float: left;
  text-align: left;
   font-size: 16px;
  text-indent: 10px;
  display: block;
  text-decoration: line-through;
  line-height: 85px;
}

.vip-s li:nth-child(2n + 1) {
  margin: 0 0px 1px 0;
  float: left;
    width: 49.55%;
}
.vip-s li:nth-child(2n) {
  margin: 0 1px 1px 0px;
  float: right;
    width: 49.55%;
}
/* .vip-s li img{
  position: relative;
  width: 64px;
  height: 22px;
  display: block;
  top: -74px;
  left: 190px;
} */

.vip-s-li-one img{
    position: relative;
  width: 64px;
  height: 27px;
  display: block;
  top: -74px;
  left: 190px;
}
.vip-s-li-two img{
  position: relative;
  width: 122px;
  height: 27px;
  display: block;
  top: -79px;
  left: 130px;
}

.vip-t-d{
  width: 188px;
  height: 11px;
  margin: 0 auto;
}

.vip-t-d img{
  width: 100%;
  height: 100%;
}
.vip-t-desc{
  width:587px;
  height:131px;
  font-size:24px;
  font-family:PingFang SC;
  font-weight:400;
  color:rgba(241,195,167,1);
  line-height:36px;
  opacity:0.7;
  margin: 50px auto  0;
  text-align: left;

}

.vip-t-desc-span{
  color: #DB7B40;
}
.vip-t-desc-t{
    font-size:20px;
     color:rgba(241,195,167,1);
}
.vip-yong-text{
  width: 630px;
  height: 21px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #76646A;
  text-align: center;
  margin: 10px auto 0 auto;
}

</style>


// WEBPACK FOOTER //
// src/components/page/userVipNew2.vue